import LeadLabelsList from './LeadLabelsList';
import LeadLabelsItem from './LeadLabelsItem';

export {
  LeadLabelsList,
  LeadLabelsItem,
};



// WEBPACK FOOTER //
// ./src/components/LeadLabels/index.js